<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M11 12L15 12" />
  <path d="M11 4L11 20" />
  <path d="M11 4L17 4" />
  <path d="M19 10L22 20" />
  <path d="M19 4L19 20" />
  <path d="M19 4L21 4C22 4 22 5 22 7C22 9 22 10 21 10L19 10" />
  <path
    d="M2 7C2 5 3 4 5 4L6 4C8 4 9 5 9 7C9 9 8 10 6 10L5 10C3 10 2 11 2 13C2 15 3 16 5 16L6 16C8 16 9 15 9 13"
  />
</svg>
